module.exports = __webpack_public_path__ + "img/img-6.47b1af16.jpg";